import React from 'react';

const ConfiguracaoConfig = {
  settings: {
    layout: {
      config: {},
    },
  },
  routes: [
    {
      path: '/configuracao',
      component: React.lazy(() => import('./Configuracao')),
    },
  ],
};

export default ConfiguracaoConfig;
